<style scoped>
/* Style the input fields */
input {
  padding-inline: 12px;
  padding-top: 7px;
  padding-bottom: 7px;
  width: 100%;
  font-size: 16px;
  font-family: Raleway;
  border: none;
  background-color: initial;
  outline: 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1.5px solid rgba(0, 123, 255);
  color: gray;
  border-radius: 20px;
  font-weight: bold;
}
.slct {
  width: 100%;
  font-size: 18px;
  font-family: Raleway;
  border: none;
  background-color: initial;
  outline: 0;
  border-bottom: 1.5px solid rgba(0, 123, 255);
  color: black;
  border-radius: 10px;
}
select {
  background-color: initial;
}
textarea {
  height: 70px;
  width: 100%;
  font-size: 18px;
  font-family: Raleway;
  border: none;
  background-color: initial;
  outline: 0;
  border-radius: 20px;
}

/* Hide all steps by default: */
.tab {
  display: none;
}

/* Mark input boxes that gets an error on validation: */
input.invalid,
textarea.invalid {
  background-color: rgba(255, 0, 0, 0.1);
  border-bottom: 2px solid red;
}

/* Make circles that indicate the steps of the form: */
.step {
  height: 22px;
  width: 22px;
  margin: 0 5px;
  border: none;
  display: inline-block;
  opacity: 0.2;
}

/* Mark the active step: */
.step.active {
  opacity: 1;
  height: 25px;
  width: 25px;
}

/* Mark the steps that are finished and valid: */
.step.finish {
  background-color: #04aa6d;
}
</style>
<template>
  <div
    class="container mt-3 p-3 rounded card card-with-shadow shadow-sm"
    style="
      background-color: rgb(0, 123, 255, 0.02);
      border: 1.5px solid rgba(0, 123, 255);
    "
  >
    <div class="card-header">
      <h4 class="font-weight-bold">Grand titre du formulaire</h4>
    </div>
    <div class="card-body">
      <form action="">
        <!-- One "tab" for each step in the form: -->
        <div class="tab" v-for="i in nb" :key="i">
          <h4 class="text-center text-primary font-weight-bold">
            Title page {{ i }}
          </h4>
          <div class="row mt-4">
            <div class="col-lg-6 mb-4 col-md-6">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for=""
                style="font-size: 15px;"
                >First name</label
              >
              <div>
                <input
                  type="text"
                  placeholder="First name"
                  oninput="this.className = ''"
                />
              </div>
            </div>
            <div class="col-lg-6 mb-4 col-md-6">
              <div class="">
                <button
                type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                  class="mr-1 p-1 ml-2 shadow-sm border-0"
                  style="background-color: initial"
                >
                  <i class="fas fa-info text-secondary"></i>
                </button>
                <label
                  for="name"
                  style="font-size: 15px;"
                  >Last name</label
                >
              </div>
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Last name"
                  oninput="this.className = ''"
                />
              </div>
            </div>
            <div class="col-lg-12 mb-4">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for="email"
                class=""
                style="font-size: 15px;"
                >Email</label
              >
              <div>
                <input
                  type="email"
                  placeholder="mail"
                  name="email"
                  oninput="this.className = ''"
                />
              </div>
            </div>
            <div class="col-lg-6 mb-4 col-md-6">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for="number"
                class=""
                style="font-size: 15px;"
                >Number</label
              >
              <div>
                <input
                  type="number"
                  min="0"
                  placeholder="Phone"
                  oninput="this.className = ''"
                />
              </div>
            </div>
            <div class="col-lg-6 mb-4 col-md-6">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for="number"
                class=""
                style="font-size: 15px;"
                >Date</label
              >
              <div>
                <input
                  type="date"
                  name="date"
                  placeholder="Date"
                  oninput="this.className = ''"
                />
              </div>
            </div>
            <div class="col-lg-12 mb-4">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for="number"
                class="m-0"
                style="font-size: 15px;"
                >Textarea</label
              >
              <div class="slct">
                <textarea
                  name="textarea"
                  placeholder="Textarea"
                  id=""
                  class="text-secondary"
                  oninput="this.className = ''"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 mb-4 col-md-6">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for="select"
                class=""
                style="font-size: 15px;"
                >Select</label
              >
              <div class="slct">
                <select name="" id="" class="form-control">
                  <option value="1">1</option>
                  <option value="1">1</option>
                  <option value="1">1</option>
                  <option value="1">1</option>
                </select>
              </div>
            </div>
            <div class="col-lg-6 mb-4 col-md-6">
              <button
              type="button"
                data-toggle="tooltip"
                data-placement="top"
                title="Lorem ipsum dolor doloresss ipsum idolores lorbhd Lorem ipsum dolor doloresss  ipsum dolor doloresss Lorem"
                class="mr-1 p-1 ml-2 shadow-sm border-0"
                style="background-color: initial"
              >
                <i class="fas fa-info text-secondary"></i>
              </button>
              <label
                for="select"
                class=""
                style="font-size: 15px;"
                >Select</label
              >
              <div class="slct">
                <select name="" id="" class="form-control">
                  <option value="1">1</option>
                  <option value="1">1</option>
                  <option value="1">1</option>
                  <option value="1">1</option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="row d-flex justify-content-between px-3 mt-2"
            style="overflow: auto"
          >
            <div class="">
              <button
                class="btn btn-secondary"
                type="button"
                id="prevBtn"
                @click="nextPrev(-1)"
              >
                Previous
              </button>
            </div>
            <button
              class="btn btn-primary"
              type="button"
              id="nextBtn"
              @click="nextPrev(1)"
              :style="i == nb ? 'display: none' : 'display: block'"
            >
              Next
            </button>
            <button
              class="btn btn-primary"
              type="submit"
              :style="i == nb ? 'display: block' : 'display: none'"
            >
              Submit
            </button>
          </div>
        </div>
        <div
          class="row d-flex justify-content-center mt-3"
          style="text-align: center"
        >
          <span
            v-for="i in nb"
            :key="i"
            class="
              step
              bg-primary
              text-white
              d-flex
              align-items-center
              justify-content-center
              rounded
            "
            >{{ i }}</span
          >
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentTab: 0,
      nb: 3,
    };
  },
  mounted() {
    this.showTab(0); // Display the current tab
  },
  methods: {
    showTab(n) {
      // This will display the specified tab of the form ...
      var x = document.getElementsByClassName("tab");
      console.log(x);
      x[n].style.display = "block";
      // ... and fix the Previous/Next buttons:
      if (n == 0) {
        document.getElementById("prevBtn").style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }
      document.getElementById("nextBtn").innerHTML = "Next";
      // ... and run a that displays the correct step indicator:
      this.fixStepIndicator(n);
    },
    nextPrev(n) {
      // This will figure out which tab to display
      var x = document.getElementsByClassName("tab");
      // Exit the if any field in the current tab is invalid:
      if (n == 1 && !this.validateForm()) return false;
      // Hide the current tab:
      x[this.currentTab].style.display = "none";
      // Increase or decrease the current tab by 1:
      this.currentTab = this.currentTab + n;
      // Otherwise, display the correct tab:
      this.showTab(this.currentTab);
    },
    validateForm() {
      // This deals with validation of the form fields
      var x,
        y,
        i,
        textarea,
        valid = true;
      x = document.getElementsByClassName("tab");
      y = x[this.currentTab].getElementsByTagName("input");
      textarea = x[this.currentTab].getElementsByTagName("textarea");
      // A loop that checks every input field in the current tab:
      for (i = 0; i < y.length; i++) {
        // If a field is empty...
        if (y[i].value == "") {
          // add an "invalid" class to the field:
          y[i].className += " invalid";
          // and set the current valid status to false:
          valid = false;
        }
      }
      for (i = 0; i < textarea.length; i++) {
        // If a field is empty...
        if (textarea[i].value == "") {
          // add an "invalid" class to the field:
          textarea[i].className += " invalid";
          // and set the current valid status to false:
          valid = false;
        }
      }
      // If the valid status is true, mark the step as finished and valid:
      if (valid) {
        document.getElementsByClassName("step")[this.currentTab].className +=
          " finish";
      }
      return valid; // return the valid status
    },
    fixStepIndicator(n) {
      // This removes the "active" class of all steps...
      var i,
        x = document.getElementsByClassName("step");
      for (i = 0; i < x.length; i++) {
        x[i].className = x[i].className.replace(" active", "");
      }
      //... and adds the "active" class to the current step:
      x[n].className += " active";
    },
  },
};
</script>
